<template>
  <div v-if="isLoading2 == true"
    style="font-weight: 800;border-radius: 10px;padding: 50px;font-size: large;text-align: center;background: #73737326;"
    class="loader text-success">
    جاري التحميل
    <div class="spinner-border text-success" role="status">
      <span class="sr-only"></span>
    </div>
  </div>
  <div class="d-flex flex-column flex-root" id="kt_app_root">
    <!--begin::Authentication - Sign-in -->
    <div class="d-flex flex-column flex-lg-row flex-column-fluid">
      <!--begin::Body-->
      <div class="d-flex flex-column flex-lg-row-fluid w-lg-50 order-2 order-lg-1" style="background:#fafafa">
        <!--begin::Form-->
        <div class="d-flex flex-center flex-column flex-lg-row-fluid">
          <!--begin::Wrapper-->
          <div class="p-2 w-lg-500px" style="width:90%">
            <!--begin::Form-->
            <div class="p-2">
              <h1 class="mb-5 text-center">تسجيل الدخول </h1>
              <hr>
              <h1 class="mb-5 text-center text-light"
                style="font-weight: 700;font-size: larger;color: #29ca50 !important;"> Academia | أكاديميا</h1>
              <div class="loader-login-box text-center">
                <h6 style="color: #10ce36">.. الرجاء الإنتظار</h6>
                <div class="spinner-border spinner-border-lg text-light" role="status"
                  style="color: #6dff89 !important; height: 120px; width: 120px">
                  <span class="sr-only">Loading...</span>
                </div>
              </div>
              <form class="form-horizontal loginWithoutOtp" action="home.html" style="display: none">
                <div style="min-height: 10px">
                  <span id="error-message" style="color: red; display: none; text-align: right">
                    يرجى تحديد رقم الهاتف يرجى تحديد رقم الهاتف يرجى تحديد رقم
                    الهاتف يرجى تحديد رقم الهاتف</span>
                  <div id="cert-btn" style="text-align: center; display: none"></div>
                </div>
                <div class="row" dir="rtl">
                  <div class="col-md-12">
                    <div class="form-group form-group-custom mb-4" id="phone-login-box" dir="rtl">
                      <label class="text-right" for="phone">رقم الهاتف</label>
                      <div class="input-group">
                        <input type="tel" class="form-control ml-1" style="width: 100%" id="phone" maxlength="10"
                          max="9999999999" />
                      </div>
                      <span id="phone-error" style="color: red; display: none">يرجى تحديد رقم الهاتف</span>
                    </div>

                    <div class="form-group form-group-custom mb-4" dir="rtl">
                      <label for="password">كلمة المرور</label>
                      <input type="password" class="form-control" id="password" placeholder="..........." />
                      <span id="password-error" style="color: red; display: none">
                        يرجى تحديد الرمز السري</span>
                    </div>

                    <div class="row">
                      <div class="col-md-6">
                        <div class="text-md-right mt-3 mt-md-0">
                          <a href="" class="text-muted" data-bs-toggle="modal" data-bs-target="#forgetpassword-modal"><i
                              class="mdi mdi-lock"></i> نسيت كلمة المرور</a>
                        </div>
                      </div>
                    </div>
                    <div class="d-grid gap-2">
                      <div class="mt-4 login">
                        <button class="p-3 btn btn-success btn-block waves-effect waves-light"
                          style="height: 55px; font-size: 19px; width: 100%" type="button" @click="login()">
                          تسجيل دخول <i class="mdi mdi-application-export"></i>
                        </button>
                      </div>
                    </div>

                    <hr />
                    <div class="row" dir="rtl">
                      <div class="col-md-6 col-6">
                        <div class="mt-2 text-right">
                          <a href="" data-bs-toggle="modal" data-bs-target="#qr-code-modal" class="text-muted"><i
                              class="mdi mdi-qrcode"></i> رمز QR</a>
                        </div>
                      </div>
                      <div class="col-md-6 col-6">
                        <div class="mt-2 text-left">
                          <a href="register" class="text-muted"><i class="mdi mdi-account"></i> إنشاء حساب جديد</a>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </form>
              <form class="form-horizontal loginWithOtp" action="#" style="display: none">
                <div style="min-height: 10px">
                  <span id="error-message" style="color: red; display: none; text-align: right">
                    يرجى تحديد رقم الهاتف يرجى تحديد رقم الهاتف يرجى تحديد رقم
                    الهاتف يرجى تحديد رقم الهاتف</span>
                  <div id="cert-btn" style="text-align: center; display: none"></div>
                </div>
                <div class="row" dir="rtl">
                  <div class="col-md-12">
                    <div class="form-group form-group-custom mb-4" dir="rtl">
                      <label class="text-right" for="phoneOtp">رقم الهاتف</label>
                      <div class="input-group">
                        <input type="tel" class="form-control ml-1" style="width: 100%" id="phoneOtp" maxlength="10"
                          max="9999999999" />
                      </div>
                      <span id="phoneOtp-error" style="color: red; display: none">يرجى تحديد رقم الهاتف</span>
                    </div>
                    <div class="custom-radio row">
                      <div class="col-md-12 col-10">
                        <div class="form-check mb-2 float-right">
                          <input class="form-check-input" type="radio" value="1" name="sendType" id="whatsappSend"
                            checked />
                          <label class="form-check-label" for="whatsappSend" style="margin-right: 20px">
                            إرسال على الواتس أب <i class="mdi mdi-whatsapp"></i>
                          </label>
                        </div>
                      </div>
                      <br />
                      <div class="col-md-12 col-10">
                        <div class="form-check float-right" style="clear: both; margin-bottom: 20px">
                          <input class="form-check-input" type="radio" name="sendType" value="2" id="smsSend" />
                          <label class="form-check-label" for="smsSend" style="margin-right: 20px">
                            إرسال عبر SMS
                            <i class="mdi mdi-message-text-outline"></i>
                          </label>
                        </div>
                      </div>
                    </div>
                    <div class="mt-4 login sendOtp">
                      <button class="p-3 btn btn-success btn-block waves-effect waves-light" type="button"
                        @click="sendOtp" :disabled="isLoading">
                        <template v-if="isLoading">
                          <div class="spinner-border spinner-border-lg text-light" role="status">
                            <span class="sr-only">Loading...</span>
                          </div>
                        </template>
                        <template v-else>
                          إرسال رمز التحقق <i class="mdi mdi-send-outline"></i>
                        </template>
                      </button>
                      <div id="phoneOtp-error" v-if="phoneOtpError" style="display: block">
                        Error message here
                      </div>
                      <div id="phone-error" v-if="phoneError" style="display: block">
                        Error message here
                      </div>
                      <div id="error-message" v-if="errorMessage" style="display: block">
                        {{ errorMessage }}
                      </div>
                    </div>

                    <hr />
                    <div class="row" dir="rtl">
                      <div class="col-md-6 col-6">
                        <div class="mt-2 text-right">
                          <a href="" data-bs-toggle="modal" data-bs-target="#qr-code-modal" class="text-muted"><i
                              class="mdi mdi-qrcode"></i> رمز QR</a>
                        </div>
                      </div>
                      <div class="col-md-6 col-6">
                        <div class="mt-2 text-left">
                          <a href="register" class="text-muted"><i class="mdi mdi-account"></i> إنشاء حساب جديد</a>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </form>
            </div>
          </div>
          <!--end::Wrapper-->
        </div>
        <!--end::Form-->
        <!--begin::Footer-->
        <div class="w-lg-500px d-flex flex-stack px-10 mx-auto">
          <!--begin::Languages-->
          <div class="me-10"></div>
          <!--end::Languages-->
        </div>
        <!--end::Footer-->
      </div>
      <!--end::Body-->
      <!--begin::Aside-->
      <div class="d-flex flex-lg-row-fluid w-lg-50 bgi-size-cover bgi-position-center order-1 order-lg-2"
        style="background: #fff">
        <!--begin::Content-->
        <div class="d-flex flex-column flex-center py-7 py-lg-15 px-5 px-md-15 w-100">
          <!--begin::Logo-->
          <a href="#" class="mb-0 mb-lg-12">
            <img alt="Logo" src="assets/img/logo-dark.png" class="h-60px h-lg-75px" />
          </a>
          <!--end::Logo-->
          <!--begin::Image-->
          <img class="d-none d-lg-block mx-auto w-275px w-md-50 w-xl-500px mb-10 mb-lg-20"
            src="assets/img/learningv2.gif" alt="" />
          <!--end::Image-->
          <!--begin::Title-->
          <h1 class="d-none d-lg-block text-success fs-2qx fw-bolder text-center mb-7">
            أكاديميا - تعلم بلا حدود
          </h1>
          <!--end::Title-->
          <!--begin::Text-->

          <div class="d-none d-lg-block text-success fs-base text-center">
            تطبيق أكاديميا يوفر تعليم عالي الجودة لطلاب المدارس الإعدادية
            والثانوية والجامعة. بفضل ميزاته المميزة ونهجه التكنولوجي، يمكن
            للطلاب الوصول إلى محتوى تدريب متميز في أي وقت ومن أي مكان.
          </div>
          <!--end::Text-->
        </div>
        <!--end::Content-->
      </div>
      <!--end::Aside-->
    </div>
    <!--end::Authentication - Sign-in-->

    <div dir="rtl" class="modal fade qr-code-modal" id="qr-code-modal" tabindex="-1" role="dialog"
      aria-labelledby="exampleModalCenterTitle" aria-hidden="true">
      <div class="modal-dialog modal-dialog-centered" role="document">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title" id="exampleModalLongTitle">
              الدخول عن طريق QR Code
            </h5>
          </div>
          <div class="modal-body">
            <h4 class="mb-2 text-center">
              قم بمسح رمز الـ Qr لإتمام عملية الدخول
            </h4>
            <div class="qr-code-box" id="qrcode" style="
                width: 150px;
                height: 150px;
                margin-top: 15px;
                margin: 0 auto;
              "></div>
          </div>
          <div class="modal-footer">
            <button type="button" class="btn btn-secondary" data-bs-dismiss="modal">
              تراجع
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>

  <!---------------Forgot Password Modal----------------------------------------->
  <div dir="rtl" class="modal fade forgetpassword-modal" id="forgetpassword-modal" tabindex="-1" role="dialog"
    aria-labelledby="exampleModalCenterTitle" aria-hidden="true">
    <div class="modal-dialog modal-dialog-centered" role="document">
      <div class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title" id="exampleModalLongTitle">
            نسيت كلمة المرور
          </h5>
        </div>
        <div class="modal-body">
          <h4 class="mb-2 text-center support-text">
            في حال نسيت كلمة المرور يرجى التواصل مع الدعم الفني
          </h4>
          <div class="support-box">
            <img class="support-img text-center" src="assets/images/support.png" alt="" />
          </div>
          <div class="phones-box">
            <h5><i class="fa fa-phone"></i> 0913103064 ( تليغرام)</h5>
          </div>
        </div>
        <div class="modal-footer">
          <button type="button" class="btn btn-secondary" data-bs-dismiss="modal">
            تراجع
          </button>
        </div>
      </div>
    </div>
  </div>
  <!---------------Download App Modal----------------------------------------->
  <div dir="rtl" class="modal fade forgetpassword-modal" id="download-modal" tabindex="-1" role="dialog"
    aria-labelledby="exampleModalCenterTitle" aria-hidden="true">
    <div class="modal-dialog modal-dialog-centered" role="document">
      <div class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title" id="exampleModalLongTitle">
            إنشاء حساب جديد
          </h5>
        </div>
        <div class="modal-body">
          <h4 class="mb-2 text-center support-text">
            يمكنك إنشاء حساب جديد عبر تحميل تطبيق أكاديميا من الرابط أدناه
          </h4>
          <div class="support-box">
            <img class="support-img text-center" src="assets/images/icon.png" alt="" />
          </div>
          <div class="text-center">
            <h5 class="download-app">
              <i class="fa fa-link"></i>
              <a href="https://onelink.to/speetar.academia">رابط تحميل التطبيق</a>
            </h5>
          </div>
        </div>
        <div class="modal-footer">
          <button type="button" class="btn btn-secondary" data-bs-dismiss="modal">
            تراجع
          </button>
        </div>
      </div>
    </div>
  </div>
  <div dir="rtl" class="modal fade verifyOtp-modal" id="verifyOtp-modal" tabindex="-1" role="dialog"
    aria-labelledby="exampleModalCenterTitle" aria-hidden="true">
    <div class="modal-dialog modal-md modal-dialog-centered" role="document" style="max-width: 381px">
      <div class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title" id="exampleModalLongTitle">
            أدخل رمز التحقق
          </h5>
          <span type="button" class="btn btn-light" data-bs-dismiss="modal"><i class="mdi mdi-close"></i></span>
        </div>
        <div class="modal-body">
          <div width="100%">
            <img style="
                border-radius: 10px;
                width: 173px;
                color: #00c544;
                padding: 15px 20px;
                line-height: 80px;
                font-size: 130px;
                display: block;
                margin: 0 auto;
                text-align: center;
              " class="support-img text-center" src="assets/img/pin.png" alt="" />
          </div>
          <h5 class="mb-2 text-center support-text" style="
              color: #00370f;
              background: #e4ffee;
              font-size: 14px;
              font-weight: 600;
              padding: 5px;
              border-radius: 5px;
            ">
            أدخل أدناه رمز التحقق المرسل الى رقم هاتفك عبر SMS
          </h5>
          <form class="form-horizontal verifyOtpForm" action="#">
            <div style="min-height: 10px">
              <span id="error-message" style="color: red; display: none; text-align: right">
                يرجى تحديد رقم الهاتف يرجى تحديد رقم الهاتف يرجى تحديد رقم
                الهاتف يرجى تحديد رقم الهاتف</span>
              <div id="cert-btn" style="text-align: center; display: none"></div>
            </div>
            <div class="row" dir="rtl">
              <div class="col-md-12">
                <div class="form-group form-group-custom mb-4" dir="rtl">
                  <div class="input-group">
                    <input type="text" class="form-control" id="Otp" placeholder="________________" style="
                        width: 100%;
                        background: #eeeeee;
                        border: 0px;
                        font-size: 25px;
                        text-align: center;
                      " />
                  </div>
                  <span id="Otp-error" style="color: red; display: none">يرجى تحديد رمز التحقق
                  </span>
                </div>
                <div class="mt-4 verifyOtp">
                  <button class="p-3 btn btn-success btn-block waves-effect waves-light" type="button"
                    @click="verifyOtp">
                    إدخال الرمز <i class="mdi mdi-check-bold"></i>
                  </button>
                </div>
                <span id="error-verifyOtp-messager" style="color: red; display: none">
                </span>
              </div>
            </div>
          </form>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { hashV2 } from "@/utils/api";
import QRCode from "qrcodejs2";

import { apiUrl, deviceId, baseUrl, getBrowserName } from "@/utils/api"; // Adjust the import path according to your project structure
// Adjust the import path according to your project structure
var iti;

export default {
  name: "Login",
  data() {
    return {
      phoneOtpError: false,
      phoneError: false,
      errorMessage: "",
      isLoading2: true
    };
  },
  mounted() {
    this.getBalance();
    $(document).ready(function () {
      var qrcode = new QRCode(document.getElementById("qrcode"), {
        width: 150,
        height: 150,
      });

      qrcode.makeCode(deviceId + "//" + getBrowserName());
      $(".loginWithoutOtp").hide();
      $(".loginWithOtp").hide();
      $.ajax({
        //url: "http://ec2-157-175-164-163.me-south-1.compute.amazonaws.com/api/home?secret=a463c0cd-78ed-4bda-a5f6-f70c3e597dfb",
        url: apiUrl + "/home/web",
        method: "GET",
        dataType: "json",
        success: function (response) {
          //console.log(response);
          $(".loader-login-box").hide();

          var otpStatus = 0;
          var phone;
          if (otpStatus == 0) {
            $(".loginWithoutOtp").show();
            $(".loginWithOtp").hide();
            phone = document.querySelector("#phone");
          }
          if (otpStatus == 1) {
            $(".loginWithoutOtp").hide();
            $(".loginWithOtp").show();
            phone = document.querySelector("#phoneOtp");
          }
          iti = intlTelInput(phone, {
            utilsScript: "assets/js/utils.js",
            initialCountry: "ly", // Set Libya as the default country
            separateDialCode: true,
            excludeCountries: ["il"],
          });
        },
        error: function (error) {
          //console.log("Error:", error);
        },
      });
    });

    if (localStorage.getItem("access_token")) {
      //console.log(localStorage.getItem('access_token'));
      //alert(localStorage.getItem("access_token"));
      //window.location.href = "/home";
    }
    //console.log(localStorage.getItem('respo'));

    document
      .querySelector(".loginWithOtp")
      .addEventListener("submit", (event) => {
        event.preventDefault();
      });

    document
      .querySelector(".verifyOtpForm")
      .addEventListener("submit", (event) => {
        event.preventDefault();
      });

    document.querySelector("#phone").addEventListener("keyup", (event) => {
      if (event.keyCode === 13) {
        this.login();
      }
    });

    document.querySelector("#password").addEventListener("keyup", (event) => {
      if (event.keyCode === 13) {
        this.login();
      }
    });

    document.querySelector("#phoneOtp").addEventListener("keyup", (event) => {
      if (event.keyCode === 13) {
        this.sendOtp();
      }
    });

    document.querySelector("#Otp").addEventListener("keyup", (event) => {
      if (event.keyCode === 13) {
        this.verifyOtp();
      }
    });

    document.querySelector("#phone").addEventListener("input", function (ev) {
      var maxlength = this.getAttribute("max").length;
      var value = this.value;
      if (value && value.length >= maxlength) {
        this.value = value.substr(0, maxlength);
      }
    });
  },
  methods: {
    login() {
      const $loginBtn = $(".login button");
      const $phoneErrorElem = $("#phone-error");
      const $passwordErrorElem = $("#password-error");
      const $errorMessageElem = $("#error-message");

      $phoneErrorElem.hide();
      $passwordErrorElem.hide();
      $errorMessageElem.hide();

      const mobile = $("#phone").val();
      const password = $("#password").val();
      const platform = "web";
      const version = "11.0.0";

      if (!mobile) {
        $phoneErrorElem.show();
        return;
      }
      if (!password) {
        $passwordErrorElem.show();
        return;
      }

      // Show the loading spinner
      $loginBtn.html(
        '<div class="spinner-border spinner-border-lg text-light" role="status"><span class="sr-only">Loading...</span></div>'
      );

      const payload = {
        mobile: iti.getNumber(),
        password,
        platform,
        version,
      };

      $.ajax({
        url: apiUrl + "/login/web",
        method: "POST",
        headers: {
          "Content-Type": "application/x-www-form-urlencoded",
          Accept: "application/json",
          Authorization: "Bearer oeKNF8MEnoTtcaCOAcr0XT7dYQgnLXUsiyTNyGvY",
        },
        data: hashV2(payload),
      })
        .done((response) => {
          if (response.message) {
            $errorMessageElem.text(response.message).show();
          } else if (response.access_token) {
            localStorage.setItem("access_token", response.access_token);
            localStorage.setItem("expires_in", response.expires_in);
            console.log(response);

            // تحقق من وجود access_token قبل التوجيه
            if (localStorage.getItem("access_token")) {
              window.location.href = "/home";
            }
          }

        })
        .fail((response) => {
          const res = response.responseJSON;
          if (res.message) {
            $errorMessageElem.text(res.message).show();
            if (response.status == 406) {
              $("#cert-btn")
                .html(
                  "<a href=" +
                  baseUrl +
                  'login-verify-users" target="_blank" class="btn btn-sm btn-success text-center cert- mt-2"><i class="fa fa-arrow-right"></i>  توثيق الأن  </a>'
                )
                .show();
            }
          }
        })
        .always(() => {
          // Restore the original button text after the request is done
          $loginBtn.html(
            'تسجيل دخول <i class="mdi mdi-application-export"></i>'
          );
        });
    },
    // End Update By Alfaqieh 27/7/2023
    sendOtp() {
      this.phoneOtpError = false;
      this.phoneError = false;
      this.errorMessage = "";

      let mobile = document.getElementById("phoneOtp").value;

      if (!mobile) {
        this.isLoading = false;
        this.phoneError = true;
        alert("الرجاء إدخال رقم الهاتف");

        return;
      }

      mobile = iti.getNumber();

      const sendType = document.querySelector(
        'input[name="sendType"]:checked'
      ).value;
      let payload = {
        mobile,
        whatsapp: sendType === "1",
        sms: sendType === "2",
      };

      var settings = {
        url: apiUrl + "/send-otp",
        method: "POST",
        timeout: 0,
        headers: {
          "Content-Type": "application/x-www-form-urlencoded",
          Accept: "application/json",
        },
        data: payload,
      };

      //console.log(settings);

      $.ajax(settings)
        .done((response) => {
          this.isLoading = false;
          localStorage.setItem("respo", response.access_token);

          if (response.message) {
            $("#verifyOtp-modal").modal("show");
            alertify.success(response.message);
          } else {
            this.errorMessage = response.message;
            alertify.error(response.message);
          }
        })
        .fail((response) => {
          this.isLoading = false;
          this.errorMessage = response.responseJSON.message;
          alertify.error(response.responseJSON.message);
        });
    },
    verifyOtp() {
      const $verifyOtpBtn = $(".verifyOtp button");

      // Show the loading spinner on the button
      $verifyOtpBtn.html(
        '<div class="spinner-border spinner-border-lg text-light" role="status"><span class="sr-only">Loading...</span></div>'
      );

      // Hide error messages
      document.getElementById("phoneOtp-error").style.display = "none";
      document.getElementById("Otp-error").style.display = "none";

      let mobile = document.getElementById("phoneOtp").value;
      let otp = document.getElementById("Otp").value;

      if (!mobile) {
        // Restore the original button content if mobile number is missing
        $verifyOtpBtn.html('إدخال الرمز <i class="mdi mdi-check"></i>');
        document.getElementById("phoneOtp-error").style.display = "block";
        console.log("mobile");
        return;
      }

      if (!otp) {
        // Restore the original button content if OTP is missing
        $verifyOtpBtn.html('إدخال الرمز <i class="mdi mdi-check"></i>');
        document.getElementById("Otp-error").style.display = "block";
        console.log("otp");
        return;
      }

      mobile = iti.getNumber();
      let payload = {
        mobile,
        otp,
      };

      const settings = {
        url: apiUrl + "/verify-otp",
        method: "POST",
        timeout: 0,
        headers: {
          "Content-Type": "application/x-www-form-urlencoded",
          Accept: "application/json",
        },
        data: payload,
      };

      $.ajax(settings)
        .done((response) => {
          console.log("response.status: ", response.status);
          console.log(response);
          const res = response;
          localStorage.setItem("respo", res.access_token);

          if (res.message) {
            $("#verifyOtp-modal").modal("hide");
            $(".loginWithOtp").hide();
            $(".loginWithoutOtp").show();
            alertify.success(res.message);
            $("#phone-login-box").hide();
            $("#phone").val(iti.getNumber());
          } else {
            // Restore the original button content if there is no message
            $verifyOtpBtn.html('إدخال الرمز <i class="mdi mdi-check"></i>');
          }
        })
        .fail((response) => {
          //console.log(response);
          console.log("fail.status: ", response.status);
          alertify.error("رمز التحقق غير صحيح");

          // Restore the original button content after the request fails
          $verifyOtpBtn.html('إدخال الرمز <i class="mdi mdi-check"></i>');

          // Restore the send OTP button content
          $(".sendOtp button").html(
            'إرسال رمز التحقق <i class="mdi mdi-message"></i>'
          );
        });
    },
    async getBalance() {
      // إخفاء الـ body
      console.log("Hiding body...");
      $('#kt_app_root').addClass('hidden-login');
      try {
        const response = await fetch(
          `${apiUrl}/wallets/get-balance?secret=a463c0cd-78ed-4bda-a5f6-f70c3e597dfb`,
          {
            method: "GET",
            headers: {
              Authorization: `Bearer ${this.token}`,
              "Content-Type": "application/json",
            },
          }
        );
        this.isLoading2 = false;
        if (response.redirected) {

          $('#kt_app_root').removeClass('hidden-login');

        }
        else {
          window.location.href = "/home";
        }
      } catch (error) {
        console.error("Error fetching balance:", error);
      } finally {

      }
    }


  },
};
</script>
<style scoped>
.form-control {
  height: 55px;
  font-size: 19px;
  width: 100%;
}
</style>
